import { render, staticRenderFns } from "./BeneficiarySearch.vue?vue&type=template&id=8f85481a&scoped=true"
import script from "./BeneficiarySearch.vue?vue&type=script&lang=js"
export * from "./BeneficiarySearch.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=8f85481a&prod&scoped=true&lang=css&external"
import style1 from "./BeneficiarySearch.vue?vue&type=style&index=1&id=8f85481a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f85481a",
  null
  
)

export default component.exports